<template>
    <v-alert
        v-model="flg"
        :dismissible="isDismissible"
        type="error"
        class="shape cutie mt-3 AlertError_alert text-caption"
    >
        {{ titleMessage }}<br />
        <ul v-if="detailMessages.length > 0" style="display: inline-block">
            <li v-for="(error, index) in detailMessages" :key="index" class="error-code-and-message">
                {{ `${error.code} - ${error.message}` }}
                <ul v-if="error.more_detailed_errors && error.more_detailed_errors.length > 0">
                    <li
                        v-for="(detailed_error, detailed_index) in error.more_detailed_errors"
                        :key="detailed_index"
                        class="error-code-and-message"
                    >
                        {{ `${detailed_error.title} : ${detailed_error.code} - ${detailed_error.message}` }}
                    </li>
                </ul>
            </li>
        </ul>
    </v-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ErrorDetail } from '../../store/types';

@Component({
    name: 'AlertError',
})
export default class AlertError extends Vue {
    @Prop({ default: false }) value: boolean;
    @Prop({ default: '' }) title: string;
    @Prop({ default: () => [] }) details: Array<ErrorDetail>;
    @Prop({ default: false }) dismissible: boolean;
    @Watch('value', { immediate: true })
    onValueChanged(val: boolean): void {
        this.flg = val;
    }

    flg = false;

    get titleMessage(): string {
        return this.title;
    }
    get detailMessages(): Array<ErrorDetail> {
        return this.details;
    }
    get isDismissible(): boolean {
        return this.dismissible;
    }
}
</script>

<style lang="scss" scoped>
.AlertError_alert :deep(.v-alert__content) {
    width: 0; // IE11対策
    min-width: 0; // flexboxの横幅を固定させるやつ
}
.error-code-and-message {
    word-wrap: break-word;
    overflow-wrap: break-word;
}
.AlertError_alert ul ul {
    list-style-type: disc;
}
</style>
